import { withFeatureBranch } from '../../../redux/flags';
import AddToGroupButton from './AddToGroupButton';
import AddToGroupButtonContainer from './AddToGroupButton.container';
import AddToGroupButtonWithPopover from './AddToGroupButtonWithPopover';
export default withFeatureBranch({
    add_to_group_2: AddToGroupButtonContainer(AddToGroupButtonWithPopover),
})(AddToGroupButtonContainer(AddToGroupButton));
//# sourceMappingURL=index.js.map